import script from "./index.vue?vue&type=script&setup=true&lang=ts"
export * from "./index.vue?vue&type=script&setup=true&lang=ts"

import "./index.vue?vue&type=style&index=0&id=7ea45f84&scoped=true&lang=less"

import exportComponent from "/Users/nikkizeng/Desktop/running/ph-miao-wechat/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ea45f84"]])

export default __exports__